const HEADER_COMMENT = '/** auto generated, do not edit */';

export { HEADER_COMMENT };

export function ensureHeaderComment(source: string): string {
  let text = source.startsWith('\uFEFF') ? source.slice(1) : source;

  while (text.startsWith(HEADER_COMMENT)) {
    text = text.slice(HEADER_COMMENT.length);
    text = stripLeadingNewlines(text);
  }

  const trimmed = stripLeadingNewlines(text);
  if (trimmed.length === 0) {
    return `${HEADER_COMMENT}\n`;
  }

  return `${HEADER_COMMENT}\n${trimmed}`;
}

export function stripLeadingNewlines(value: string): string {
  let current = value;
  while (current.startsWith('\r\n') || current.startsWith('\n')) {
    current = current.startsWith('\r\n') ? current.slice(2) : current.slice(1);
  }
  return current;
}

export function collapseExtraBlankLines(text: string): string {
  return text.replace(/\n{3,}/g, '\n\n');
}
